import React from 'react'
import { Button, Text } from 'components/base'

export default function ErrorMessage({
  message,
  retry,
  action = 'getting your billing information',
}) {
  return (
    <div className="">
      <Text.Title>Oops, something went wrong</Text.Title>
      <div className="shade-20 margin-vertical-medium">
        Something went wrong while {action}. Please try again. If the problem
        persists contact support with the following message:
      </div>
      <div className="margin-vertical-medium border-shade-30 border-small padding-normal radius-normal">
        {message}.
      </div>
      <div className="flexbox">
        <Button.Primary className="margin-right-normal" onClick={retry}>
          Try again
        </Button.Primary>
        <Button.Secondary
          onClick={() => {
            window.Intercom
              ? window.Intercom('show')
              : window.open('mailto:contact@slite.com')
          }}
        >
          Contact support
        </Button.Secondary>
      </div>
    </div>
  )
}
